import FtrQuickLinks from './FtrQuickLinks';
export default FtrQuickLinks;